import * as React from 'react';
import classnames from 'classnames';

import '../../footer/tile-standard-footer.scss';
import './tile-standard-loading-footer.scss';

import type { TileStandardSize } from 'types';

type Props = {
  tileSize: TileStandardSize
};

const TileStandardLoadingFooter = (
  {
    tileSize
  }: Props
): JSX.Element => {
  const containerClasses = classnames('tile-standard-footer', {
    'tile-standard-footer--is-hidden': tileSize === 'collapsed'
  });

  return (
    <div className={containerClasses}>
      <div className="tile-standard-footer__icons">
        <div className="tile-standard-footer__actions">
          <div className="tile-standard-loading-footer__actions--icon" />
          <div className="tile-standard-loading-footer__actions--icon" />
          <div className="tile-standard-loading-footer__actions--icon" />
        </div>
      </div>
    </div>
  );
};

export default TileStandardLoadingFooter;
